import React from 'react'
import { connect } from 'react-redux'
import { CardSection } from '../../../completion/components/Card'
import * as actions from '../../actions'
import Tagging from './components/Tagging'

const TaggingContainer = (props) => (
  <CardSection last {...props} >
    <Tagging {...props} />
  </CardSection>
)

const mapStateToProps = (state) => ({
  diagnosis: state.feedback.tagging.diagnosis,
  doctor: state.feedback.tagging.doctor,
  customSubmitted: state.feedback.tagging.customSubmitted,
  custom: state.feedback.tagging.custom || undefined,
  finished: state.feedback.tagging.finished
})

const TaggingContainerWrapper = connect(mapStateToProps, actions)(TaggingContainer)

export {TaggingContainerWrapper as default, TaggingContainer}



// WEBPACK FOOTER //
// ./assets/feedback/components/tagging/index.js